module.exports = __webpack_public_path__ + "img/rotate-icon.bc73d3d5.svg";